export default "__VITE_ASSET__35f89265__"